import { h } from 'preact';
import { Text } from 'preact-i18n';

const COUNT_UNITS = new Set([
    'aktivering',
    'aktiveringer',
    'dose',
    'doser',
    'spray',
    'sprøyte',
    'sprøyter',
    'stk',
    'stykk',
]);

const MEASUREMENT_UNITS = new Set([
    'cm',
    'cm2',
    'e',
    'g',
    'ie',
    'iu',
    'kg',
    'l',
    'mg',
    'mikrog',
    'ml',
]);

function parsePackFactors(packSize) {
    if (typeof packSize !== 'string') return null;

    const factors = packSize
        .trim()
        .split(/\s*x\s*/i)
        .map(value => value.replace(',', '.'));

    if (factors.length < 2 || factors.some(value => !/^\d+(?:\.\d+)?$/.test(value))) {
        return null;
    }

    return factors.map(Number);
}

export function getPrescriptionPackageTotal(drug = {}) {
    const factors = parsePackFactors(drug.pakningsinfoPakningsstr);
    if (!factors) return null;

    const unit = String(drug.pakningsinfoEnhetPakningV || '').trim().toLowerCase();
    let unitsPerPackage;
    if (COUNT_UNITS.has(unit)) {
        unitsPerPackage = factors.reduce((total, value) => total * value, 1);
    } else if (MEASUREMENT_UNITS.has(unit)) {
        unitsPerPackage = factors[0];
    } else {
        return null;
    }

    const packageCount = Number(drug.qty || 1);
    const totalUnits = packageCount * unitsPerPackage;
    if (
        !Number.isInteger(packageCount)
        || packageCount < 1
        || !Number.isInteger(unitsPerPackage)
        || unitsPerPackage <= 1
        || !Number.isInteger(totalUnits)
    ) {
        return null;
    }

    return {
        packageCount,
        totalUnits,
        unitsPerPackage,
    };
}

export function PrescriptionPackageTotal({ drug, className = '' }) {
    const packageTotal = getPrescriptionPackageTotal(drug);
    if (!packageTotal) return null;

    return (
        <div class={`prescription-package-total ${className}`}>
            <i class='fa-solid fa-calculator me-1' />
            <Text
                id='dyrejournal.prescription.totalUnits'
                fields={{ total: packageTotal.totalUnits }}
            >
                Total individual units: {packageTotal.totalUnits}
            </Text>
        </div>
    );
}

export default PrescriptionPackageTotal;
